let environmentName = "dev";
let config = {
    orderBucketUrl: "https://s3.console.aws.amazon.com/s3/buckets/cs2-dev-us-east-1-order-data-bucket/OrderData/",
    diagnosticApiHost: "https://api." + environmentName + ".diagnostics.closesimple.com/",
    adminAuthApiHost: "https://api.auth" + environmentName + ".admin.closesimple.com/",
    adminAuthHost: "https://auth" + environmentName + ".admin.closesimple.com/",
    cognitoClientId: "2vh736i87nfj7iho4opdne0lig"
};

config.tokenUrl = config.adminAuthHost + "authorize?response_type=code&client_id=" + config.cognitoClientId + "&redirect_uri=" + window.location.origin + "&scope=openid+profile+aws.cognito.signin.user.admin&state=";

config.apiOptions = (method, body) => {
    var options = {
        method: method,
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'AnyVal'
        },
        credentials: "include"
    };
    if (body) {
        options.body = body;
    }
    return options;
};

module.exports = config;